<ng-container [formGroup]="formGroupCampaign">
    <app-mdb-switch label="Hide option for donor to cover Fee" formControlName="hideCoverFee"></app-mdb-switch>
    <div class="divider"></div>
    <app-mdb-switch label="Make default state for cover fee unchecked" formControlName="coverFeeDefaultOff"></app-mdb-switch>
    <div class="divider"></div>
</ng-container>